import { defineStore } from "pinia";
import { getNetwork } from "@/api/apiclient/user";
import { networkType } from "@/types/network";

export const useNetwork = defineStore("network", {
  state: () => {
    return {
      list: [] as networkType[],
    };
  },
  actions: {
    async loadList() {
      const list = await getNetwork();
      this.list = list;
    },
  },
  getters: {
    
  },
});
